module.exports = __webpack_public_path__ + "img/bulletins-update.6b8d717a.svg";